import React from 'react';
import {
  useChannelStateContext,
  Message,
} from 'stream-chat-react';
import { useChannelActionContext } from 'stream-chat-react';

import './PinnedMessageList.css';
import { PinIcon } from '../../assets/PinIcon';
import { SimplePinnedMessage } from '../SimplePinnedMessage/SimplePinnedMessage';

export const PinnedMessageList = ({chatClient, channelId  }) => {
  const { channel } = useChannelStateContext();

  const hasPinnedMessages = channel.state.pinnedMessages.length > 0;

  const JumpToMessage = () => {
    const { jumpToMessage } = useChannelActionContext();
  
    return (
      <button
      className='pin-cta'
      data-testid='jump-to-message'
      onClick={async () => {
        const messageIdToJumpTo = channel.state.pinnedMessages[0].id; 
        jumpToMessage(messageIdToJumpTo);
      }}
    >
    </button>
    );
  };
  
  return (
    hasPinnedMessages ? (
      <div className='pinned-messages__container'>
            <JumpToMessage />
        <div className='pinned-messages__header'>
          <PinIcon />
          {channel.state.pinnedMessages.map((message, i) => (
            <Message
              Message={SimplePinnedMessage}
              groupStyles={['single']}
              key={message.id}
              message={message}
              onClick={() => JumpToMessage(message.id)}
            />
          ))}
        </div>
      </div>
    ) : null
  );
};
